import { atom } from 'recoil';

export const messageState = atom<string>({
  key: 'messageState',
  default: '',
});

export const messageCountState = atom<number>({
  key: 'messageCountState',
  default: 0,
});
